"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  SingleNeutralFolderBox: ['single-neutral-folder-box', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.750 9.000 A2.250 2.250 0 1 0 14.250 9.000 A2.250 2.250 0 1 0 9.750 9.000 Z', 'M15.9,14.25a4.5,4.5,0,0,0-7.792,0', 'M15,17.25a3,3,0,0,1-6,0H1.5A.75.75,0,0,0,.75,18v4.5a.75.75,0,0,0,.75.75h21a.75.75,0,0,0,.75-.75V18a.75.75,0,0,0-.75-.75Z', 'M21.75,14.25v-9a1.5,1.5,0,0,0-1.5-1.5H9.75V2.25A1.5,1.5,0,0,0,8.25.75H3.75a1.5,1.5,0,0,0-1.5,1.5v12']],
  SingleNeutralAim: ['single-neutral-aim', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M4.500 12.000 A7.500 7.500 0 1 0 19.500 12.000 A7.500 7.500 0 1 0 4.500 12.000 Z', 'M12 18L12 22.5', 'M12 1.5L12 6', 'M6 12L1.5 12', 'M22.5 12L18 12', 'M9.375 10.874 A2.625 2.625 0 1 0 14.625 10.874 A2.625 2.625 0 1 0 9.375 10.874 Z', 'M15.08,15.483a4.461,4.461,0,0,0-6.16,0']],
  SingleNeutral: ['single-neutral', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M6.750 6.000 A5.250 5.250 0 1 0 17.250 6.000 A5.250 5.250 0 1 0 6.750 6.000 Z', 'M2.25,23.25a9.75,9.75,0,0,1,19.5,0']],
  SingleNeutralIdCard4: ['single-neutral-id-card-4', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M5.625 8.625 A2.625 2.625 0 1 0 10.875 8.625 A2.625 2.625 0 1 0 5.625 8.625 Z', 'M3.75,16.5a4.5,4.5,0,0,1,9,0Z', 'M14.25 9L18.75 9', 'M14.25 12L20.25 12', 'M21.75,3H2.25A1.5,1.5,0,0,0,.75,4.5v15A1.5,1.5,0,0,0,2.25,21h3a1.5,1.5,0,0,1,3,0h7.5a1.5,1.5,0,0,1,3,0h3a1.5,1.5,0,0,0,1.5-1.5V4.5A1.5,1.5,0,0,0,21.75,3Z']],
  SingleNeutralMonitor: ['single-neutral-monitor', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.375 7.875 A2.625 2.625 0 1 0 14.625 7.875 A2.625 2.625 0 1 0 9.375 7.875 Z', 'M7.5,15.75a4.5,4.5,0,0,1,9,0', 'M1.500 2.250 L22.500 2.250 L22.500 18.750 L1.500 18.750 Z', 'M12 18.75L12 21.75', 'M4.5 21.75L19.5 21.75']],
  SingleNeutralNews: ['single-neutral-news', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.375 7.875 A2.625 2.625 0 1 0 17.625 7.875 A2.625 2.625 0 1 0 12.375 7.875 Z', 'M10.5,15.75a4.5,4.5,0,0,1,9,0', 'M1.500 2.250 L22.500 2.250 L22.500 18.750 L1.500 18.750 Z', 'M12 18.75L12 21.75', 'M4.5 21.75L19.5 21.75', 'M4.5 5.25H9V9.75H4.5z']],
  SingleNeutralShield: ['single-neutral-shield', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25,9.937A13.5,13.5,0,0,1,12,23.25,13.5,13.5,0,0,1,.75,9.937V2.25A1.5,1.5,0,0,1,2.25.75h19.5a1.5,1.5,0,0,1,1.5,1.5Z', 'M8.625 8.625 A3.375 3.375 0 1 0 15.375 8.625 A3.375 3.375 0 1 0 8.625 8.625 Z', 'M17.387,16.75a6.032,6.032,0,0,0-10.774,0']],
  SingleNeutralProfilePicture: ['single-neutral-profile-picture', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M2.250 0.750 L21.750 0.750 L21.750 23.250 L2.250 23.250 Z', 'M7.890 9.083 A4.110 4.110 0 1 0 16.110 9.083 A4.110 4.110 0 1 0 7.890 9.083 Z', 'M18.75,19.027a7.63,7.63,0,0,0-13.5,0']],
  SingleNeutralPodium: ['single-neutral-podium', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M4.5 15.75L19.5 15.75', 'M15.75 23.25L8.25 23.25 7.5 15.75 16.5 15.75 15.75 23.25z', 'M9.000 3.750 A3.000 3.000 0 1 0 15.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 Z', 'M16.5,12.75a4.5,4.5,0,0,0-9,0']],
  SingleNeutralIdCard3: ['single-neutral-id-card-3', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.75,5.25H2.25a1.5,1.5,0,0,0-1.5,1.5v13.5a1.5,1.5,0,0,0,1.5,1.5h19.5a1.5,1.5,0,0,0,1.5-1.5V6.75a1.5,1.5,0,0,0-1.5-1.5h-7.5', 'M14.25,4.5a2.25,2.25,0,0,0-4.5,0v3a.75.75,0,0,0,.75.75h3a.75.75,0,0,0,.75-.75Z', 'M5.625 13.875 A2.625 2.625 0 1 0 10.875 13.875 A2.625 2.625 0 1 0 5.625 13.875 Z', 'M3.75,21.75a4.5,4.5,0,0,1,9,0Z', 'M14.25 12.75L18.75 12.75', 'M14.25 15.75L20.25 15.75']],
  SingleNeutralIdCardDouble: ['single-neutral-id-card-double', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M5.625 10.875 A2.625 2.625 0 1 0 10.875 10.875 A2.625 2.625 0 1 0 5.625 10.875 Z', 'M3.75,18.75a4.5,4.5,0,0,1,9,0Z', 'M14.25 11.25L18.75 11.25', 'M14.25 14.25L20.25 14.25', 'M21.75,5.25H2.25a1.5,1.5,0,0,0-1.5,1.5v15a1.5,1.5,0,0,0,1.5,1.5h3a1.5,1.5,0,0,1,3,0h7.5a1.5,1.5,0,0,1,3,0h3a1.5,1.5,0,0,0,1.5-1.5v-15A1.5,1.5,0,0,0,21.75,5.25Z', 'M23.25,2.25a1.5,1.5,0,0,0-1.5-1.5H2.25a1.5,1.5,0,0,0-1.5,1.5']],
  SingleNeutralHome: ['single-neutral-home', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25 23.25L23.25 12 12 0.75 0.75 12 0.75 23.25', 'M7.875 13.125 A4.125 4.125 0 1 0 16.125 13.125 A4.125 4.125 0 1 0 7.875 13.125 Z', 'M18.365,23.25a6.751,6.751,0,0,0-12.73,0']],
  SingleNeutralPhoneBook: ['single-neutral-phone-book', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.125 9.375 A2.625 2.625 0 1 0 15.375 9.375 A2.625 2.625 0 1 0 10.125 9.375 Z', 'M8.25,17.25a4.5,4.5,0,0,1,9,0', 'M5.25 0.75L5.25 23.25', 'M23.25 3L23.25 6', 'M23.25 9L23.25 12', 'M23.25 15L23.25 18', 'M0.750 0.750 L20.250 0.750 L20.250 23.250 L0.750 23.250 Z']],
  SingleNeutralIdCard1: ['single-neutral-id-card-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.75,3.75H5.25a1.5,1.5,0,0,0-1.5,1.5v16.5a1.5,1.5,0,0,0,1.5,1.5h13.5a1.5,1.5,0,0,0,1.5-1.5V5.25a1.5,1.5,0,0,0-1.5-1.5h-4.5', 'M14.25,3a2.25,2.25,0,0,0-4.5,0V6a.75.75,0,0,0,.75.75h3A.75.75,0,0,0,14.25,6Z', 'M8.625 13.125 A3.375 3.375 0 1 0 15.375 13.125 A3.375 3.375 0 1 0 8.625 13.125 Z', 'M18,23.25a6.054,6.054,0,0,0-12,0']],
  SingleNeutralCircle: ['single-neutral-circle', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M6.750 9.750 A5.250 5.250 0 1 0 17.250 9.750 A5.250 5.250 0 1 0 6.750 9.750 Z', 'M18.913,20.876a9.746,9.746,0,0,0-13.826,0', 'M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z']],
  SingleNeutralSearch: ['single-neutral-search', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 10.500 A9.750 9.750 0 1 0 20.250 10.500 A9.750 9.750 0 1 0 0.750 10.500 Z', 'M17.394 17.394L23.25 23.25', 'M7.125 8.620 A3.375 3.375 0 1 0 13.875 8.620 A3.375 3.375 0 1 0 7.125 8.620 Z', 'M15,15.494a6.065,6.065,0,0,0-9,0']],
  SingleNeutralIdCard2: ['single-neutral-id-card-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M7.875 13.125 A3.375 3.375 0 1 0 14.625 13.125 A3.375 3.375 0 1 0 7.875 13.125 Z', 'M12.414,18.112A6.125,6.125,0,0,0,11.25,18a6.047,6.047,0,0,0-6,5.25', 'M14.25 20.25L17.25 20.25', 'M9.75,3.75H5.25a1.5,1.5,0,0,0-1.5,1.5v16.5a1.5,1.5,0,0,0,1.5,1.5h13.5a1.5,1.5,0,0,0,1.5-1.5V5.25a1.5,1.5,0,0,0-1.5-1.5h-4.5', 'M14.25,3a2.25,2.25,0,0,0-4.5,0V6a.75.75,0,0,0,.75.75h3A.75.75,0,0,0,14.25,6Z']],
  SingleNeutralVintageTv: ['single-neutral-vintage-tv', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M5.625 7.875 A2.625 2.625 0 1 0 10.875 7.875 A2.625 2.625 0 1 0 5.625 7.875 Z', 'M3.75,15.75a4.5,4.5,0,0,1,9,0', 'M0.750 2.250 L23.250 2.250 L23.250 18.750 L0.750 18.750 Z', 'M15.75 2.25L15.75 18.75', 'M18.75 11.25L20.25 11.25', 'M18.75 14.25L20.25 14.25', 'M19.5 7.5L19.5 7.5', 'M19.5,7.5a.375.375,0,1,0,.375.375A.375.375,0,0,0,19.5,7.5', 'M2.25 21.75L5.25 18.75', 'M21.75 21.75L18.75 18.75']],
  SingleNeutralFocus: ['single-neutral-focus', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M.75,6.751V2.25A1.5,1.5,0,0,1,2.25.75h4.5', 'M23.25,6.751V2.25a1.5,1.5,0,0,0-1.5-1.5h-4.5', 'M.75,17.25v4.5a1.5,1.5,0,0,0,1.5,1.5h4.5', 'M23.25,17.25v4.5a1.5,1.5,0,0,1-1.5,1.5h-4.5', 'M7.875 8.625 A4.125 4.125 0 1 0 16.125 8.625 A4.125 4.125 0 1 0 7.875 8.625 Z', 'M18.337,18.75a6.712,6.712,0,0,0-12.674,0']],
  SingleNeutralBook: ['single-neutral-book', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M21,23.25H5.25A2.25,2.25,0,0,1,3,21', 'M6,.75a3,3,0,0,0-3,3V21a2.25,2.25,0,0,1,2.25-2.25H19.5a1.5,1.5,0,0,0,1.5-1.5v-15A1.5,1.5,0,0,0,19.5.75Z', 'M19.5 23.25L19.5 18.75', 'M9.375 7.875 A2.625 2.625 0 1 0 14.625 7.875 A2.625 2.625 0 1 0 9.375 7.875 Z', 'M7.5,15.75a4.5,4.5,0,0,1,9,0']]
};
exports["default"] = _default;